import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SectiuniComponent } from './sectiuni.component';
import { AddSectiuneComponent } from './add-sectiune/add-sectiune.component';
import { EditSectiuneComponent } from './edit-sectiune/edit-sectiune.component';

@NgModule({
  declarations: [
    SectiuniComponent,
    AddSectiuneComponent,
    EditSectiuneComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [SectiuniComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SectiuniModule {}
